import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./DialogBody.styled";
export const DialogBody = forwardRef((props, ref) => {
    const { isCentered, children, ...otherProps } = props;
    return (_jsx(Styled.DialogBody, { ref: ref, isCentered: isCentered, "data-testid": "DialogBody", ...otherProps, children: children }));
});
DialogBody.displayName = "DialogBody";
DialogBody.defaultProps = {
    isCentered: false
};
